import React from "react";

import ImgSvg from "../../../../../assets/images/blockchain/emptyVoid.svg";

import s from "./MarketEmptyPage.module.scss";

export default function MarketEmptyPage({ searchText }) {
	return (
		<div className={s.root}>
			<p className={s.title}>No matching results</p>
			<img src={ImgSvg} alt="Empty img" />

			{searchText ? <p className={s.text}>
				There are no datasets with “{searchText}” in the title or descriptions. Please
				try another search.
			</p> : <p className={s.text}>
				&nbsp;
			</p>}
		</div>
	);
}
